import { Box, SxProps, Tab, Tabs, Theme } from '@mui/material';
import FolderIcon from 'assets/icons/file-cabinet-trash/tab-folder.svg';

import TrashIcon from 'assets/icons/file-cabinet-trash/tab-trash.svg';
import { SyntheticEvent } from 'react';

export enum FileCabinetTabsEnum {
  STORAGE = 'storage',
  TRASH = 'trash',
}

interface IFileCabinetTabs {
  value: FileCabinetTabsEnum;
  handleChange: (_: SyntheticEvent, newValue: FileCabinetTabsEnum) => void;
}

const TABS: {
  label: string;
  value: FileCabinetTabsEnum;
  icon: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  backgroundColor: string;
  color: string;
  sx?: SxProps<Theme>;
}[] = [
  {
    label: 'Storage',
    value: FileCabinetTabsEnum.STORAGE,
    icon: <FolderIcon />,
    backgroundColor: '#E7ECFF',
    color: '#4D6EF5',
  },

  {
    label: 'Trash',
    value: FileCabinetTabsEnum.TRASH,
    icon: <TrashIcon />,
    backgroundColor: '#FFF6F7',
    color: '#D12D36',
    sx: { marginLeft: '-1px' },
  },
];

export const FileCabinetTabs = ({ value, handleChange }: IFileCabinetTabs) => {
  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: '12px',
        display: 'inline-flex',
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        TabIndicatorProps={{ style: { display: 'none' } }}
        sx={{
          minHeight: 0,
          borderRadius: '8px',
        }}
      >
        {TABS.map((tab, index) => {
          const isSelected = value === tab.value;

          return (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
              icon={tab.icon}
              iconPosition="start"
              sx={{
                textTransform: 'none',
                minHeight: '36px',
                px: '16px',
                minWidth: 0,
                py: '0px',
                fontFamily: 'Inter',
                fontSize: 14,
                fontWeight: 400,
                border: '1px solid #EDEFF7',
                color: isSelected ? `${tab.color} !important` : '#23252F !important',
                backgroundColor: isSelected ? tab.backgroundColor : 'transparent',
                borderRadius:
                  index === 0 ? '8px 0 0 8px' : index === TABS.length - 1 ? '0 8px 8px 0' : 0,
                ...tab.sx,
              }}
            />
          );
        })}
      </Tabs>
    </Box>
  );
};
